module.exports = __webpack_public_path__ + "static/media/container.03427962.png";